<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('activity.index')">Activity Log</inertia-link>
      <span class="text-indigo-400 font-medium">/</span> {{ this.displayName }}
    </h1>
    <div class="flex flex-wrap">
      <div class="w-full">
        <div class="bg-white rounded-md shadow overflow-hidden mb-8">
            <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
              <div class="pr-6 pb-8 w-full lg:w-1/2"><span class="font-semibold block">User</span>{{ this.activity.causer }}</div>
              <div class="pr-6 pb-8 w-full lg:w-1/2"><span class="font-semibold block">Action</span>{{ this.activity.description }}</div>
              <div class="pr-6 pb-8 w-full lg:w-1/2"><span class="font-semibold block">Subject Type</span>{{ this.activity.subject_type }}</div>
              <div class="pr-6 pb-8 w-full lg:w-1/2"><span class="font-semibold block">Subject ID</span>{{ this.activity.subject_id }}</div>
              <div class="pr-6 pb-8 w-full lg:w-1/2"><span class="font-semibold block">Subject Name</span>{{ this.activity.subject_name }}</div>
              <div class="pr-6 pb-8 w-full lg:w-1/2"><span class="font-semibold block">Timestamp</span>{{ dateFormat(this.activity.timestamp) }}</div>
            </div>
        </div>
      </div>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="px-6 pt-6 pb-4">Field</th>
          <th v-if="!activity.properties.old" class="px-6 pt-6 pb-4">Value</th>
          <th v-if="activity.properties.old" class="px-6 pt-6 pb-4">New Value</th>
          <th v-if="activity.properties.old" class="px-6 pt-6 pb-4">Old Value</th>
        </tr>
        <tr v-for="(newValue, fieldName) in this.activity.properties.attributes" :key="fieldName" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <div class="px-6 py-4 flex items-center">
              {{ fieldName }}
            </div>
          </td>
          <td class="border-t">
            <div class="px-6 py-4 flex items-center">
              {{ newValue }}
            </div>
          </td>
          <td v-if="activity.properties.old" class="border-t">
            <div class="px-6 py-4 flex items-center">
              {{ activity.properties.old[fieldName] }}
            </div>
          </td>
        </tr>
      </table>
    </div>

  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import Icon from "@/Shared/Icon";
import { DateTime } from "luxon";

export default {
  metaInfo() {
    return { title: this.displayName };
  },
  components: {
    Icon,
  },
  props: {
    activity: Object,
  },
  layout: Layout,
  data() {
    return {
    }
  },
  computed: {
    displayName() {
      return this.activity.subject_type + ' ' + this.activity.subject_id;
    }
  },
  methods: {
    dateFormat(iso) {
      return DateTime.fromISO(iso).toFormat('dd LLL yyyy HH:mm ZZZZ')
    },
  },
}
</script>
